import React from 'react';
import { useHistory } from 'react-router-dom';
import { useBatchDataFetcher } from '../../../hooks';
import { ICreateSitePageFormValues } from './types';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../../form';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import { Form, ISelectOptionDataSource, toSelectOptions } from '../../../form';
import SiteForm from '../form';
import createSite from './createSite';
import SiteVisitorTypeFactory from '../form/SiteVisitorTypeFactory';
import schema from './schema';

const initialValues: ICreateSitePageFormValues = {
  pin: '',
  name: '',
  fireListIdentifier: '',
  password: '',
  themeId: null,
  emailAddress: '',
  visitorTypes: [SiteVisitorTypeFactory.Create()],
};

const urls = [
  'api/themes',
  'api/visitorTypes',
  'api/questionnaires',
  'api/visitorAgreements',
];
const config = {
  transformers: [
    (data: { themes: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.themes),
    (data: { visitorTypes: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.visitorTypes),
    (data: { questionnaires: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.questionnaires),
    (data: { agreements: Array<ISelectOptionDataSource> }) =>
      toSelectOptions(data.agreements),
  ],
};

const CreateSitePage: React.FC = () => {
  const history = useHistory();

  const {
    busy,
    errors,
    data: [themes, visitorTypes, questionnaires, agreements],
  } = useBatchDataFetcher(urls, config);

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Site" subTitle="Create" backPath="/admin/sites" />
        <AjaxErrorBoundary
          busy={busy}
          loadingText={`Loading data`}
          errors={errors}
        >
          <Form
            initialValues={initialValues}
            promise={createSite}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/sites')}
          >
            <SiteForm
              createMode
              themes={themes}
              visitorTypes={visitorTypes}
              questionnaires={questionnaires}
              agreements={agreements}
            />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};

export default CreateSitePage;
